<template>
	<div style="padding: 0 50px  50px  50px; text-align: left;">
		
			<h1 class="top-nav-tit" style="width: 100%;border-bottom: none;">
			<el-page-header @back="$router.push({path: 'enterprisemb'})" content="码标信息详情">
               </el-page-header>
			<!--<i class="el-icon-edit"></i>请填写资料-->
		</h1>
		<div style="color:#909399;">
			<p v-show="other" style="padding: 15px 0  35px 0;">
				<i class="el-icon-warning"></i>
				<span style="font-weight: 550;margin-left: 5px;">审核失败 ：</span>
				<span style="color: #F56C6C;">{{ other}}</span>
			</p>
		</div>

		<div class="Madata-box" v-if="makeover">
			<h1 class="Matit">过户信息 </h1>
			<ul class="MadataU f-cb">
				<li class="MadataL f-fl" v-for="(item,index) in makeoverData" :key="index">
					<span class="tit">{{item.title}}：</span>
					<span class="contex">{{item.context}}</span>
				</li>

			</ul>
		</div>

		<div class="Madata-box">
			<h1 class="Matit">注册信息 </h1>
			<ul class="MadataU f-cb">
				<li class="MadataL f-fl" v-for="(item,index) in registerData" :key="index" v-if="item.context != null">
					<!--{{item.context === null}}-->
					<span class="tit">{{item.title}}：</span>
					<span class="contex">{{item.context}}</span>
				</li>

				<li v-if="specialImg" class="MadataL f-fl">
					<!--{{item.context === null}}-->
					<span class="tit">运营执照：</span>
					<span class="contex">  <img  :src=" '/UploadImages/'+specialImg.licensePicture" class="Enimg-box" @click="amplificationImg(specialImg.licensePicture)"/></span>
				</li>
				<li v-if="specialImg" class="MadataL f-fl">
					<!--{{item.context === null}}-->
					<span class="tit">申请表：</span>
					<span class="contex">  
						
						
						<img v-show="/\.(jpeg|jpe|jpg|gif|png|webp|bmp)$/i.test(specialImg.limiterFile)"   :src=" '/UploadImages/'+specialImg.limiterFile" class="Enimg-box" @click="amplificationImg(specialImg.limiterFile)"/>
					<el-button type="text" v-show="/\.(rar|iso|zip|cab)$/i.test(specialImg.limiterFile)" @click="download(specialImg.limiterFile)">下载</el-button>
					</span>

				</li>
				<!--<li v-if="specialImg" class="MadataL f-fl">
					
					<span class="tit">身份证照片：</span>
					<span class="contex">
						
						<img  :src="'/UploadImages/'+specialImg.idcardPicture.split('|')[0]" class="Enimg-box" @click="amplificationImg(specialImg.idcardPicture.split('|')[0])"/>
						<img  :src="'/UploadImages/'+specialImg.idcardPicture.split('|')[1]" class="Enimg-box" @click="amplificationImg(specialImg.idcardPicture.split('|')[1])"/>
						
					</span>
				</li>-->
			</ul>
		</div>
<!--{{materialmg}}-->
		<div class="Madata-box" v-if="materialmg.length!=0">
			<h1 class="Matit">申请资料详情 </h1>
			<ul class="MadataU f-cb">
				<li class="MadataL f-fl" v-for="(item,i) in  materialmg" >
					<!--{{item.context === null}}-->
					<span class="tit">{{item.tit}}：</span>
					<span class="contex">
						 <!--v-for="itemAgain in item.context "-->
						 <!--{{item.context.split('|')}}-->
						<u-img-en v-for ="itemAgain in (item.context.split('|')) " :key="itemAgain" :src="'/UploadImages/'+ itemAgain">
								<img  :src=" '/UploadImages/'+ itemAgain " class="Enimg-box" />
						</u-img-en>
					
					</span>
				</li>

			</ul>
		</div>

		<!--{{tableData.length  == 0}}-->
		<div class="Madata-box" v-if="tableData.length  != 0">
			<h1 class="Matit">续费信息 </h1>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column prop="date" label="续费有效期">
				</el-table-column>
				<el-table-column prop="renewaltime" label="续费时间 ">
				</el-table-column>
				<el-table-column prop="state" label="状态">
				</el-table-column>
				<el-table-column prop="operation" label="操作">
					<template slot-scope="scope">
						<el-button size="small" @click="$router.push({path: 'indent',query: {indentId: scope.row.id}})" v-for="(item,index) in scope.row.types">{{item.operation}}</el-button>

						<!--{{scope.row.types}}-->
						<!--<el-button type="text" size="mini" @click="particulars(scope.row.id)" v-if="scope.row.operation ===4">续费付款</el-button>-->

					</template>

				</el-table-column>
			</el-table>
		</div>

	</div>
</template>

<script>
	import _ from "lodash";

	export default {
		data() {
			return {
				other: '',
				registerData: [{
						title: '码标',
						context: ''
					},
					//					{
					//						title: '解析IDcode',
					//						context: ''
					//					},
					{
						title: '注册有效期',
						context: ''
					},
					{
						title: '注册时间',
						context: ''
					},
					{
						title: '码标状态',
						context: ''
					},
					{
						title: '过户时间',
						context: ''
					},
					{
						title: '过户单位名称',
						context: ''
					},
					{
						title: ' 注册来源',
						context: ''
					},
					{
						title: '所属注册服务商',
						context: ''
					},
					//					{
					//						title: '运营执照',
					//						context: ''
					//					},
					//					{
					//						title: '限制词注册申请表',
					//						context: ''
					//					},
					//					{
					//						title: '企业负责人身份证照片',
					//						context: ''
					//					},
				],
				materialmg: [],
				specialImg: '',

				registeroperation: [],
				makeoverData: [{
						title: '过户单位名称',
						context: ''
					},
					{
						title: '过户时间',
						context: ''
					},
				],
				makeover: false,
				tableData: [],
				payment_order: ''
			}
		},
		props: {

			id: [String, Number],

		},
		created() {
			this.Madata();
		},
		methods: {
			amplificationImg(url) {
				this.$alert('<img src=' + '/UploadImages/' + url + '></img>', {
					showConfirmButton: false,
					dangerouslyUseHTMLString: true,
					customClass: 'imgalert',
					callback: (done) => {
						//						done();
					}
				});
			},
			download(url) {
				window.location = window.location.protocol + "//" + window.location.host + '/UploadImages/' + url;

			},
			Madata() {
				this.$http.get(this.$api + '/identificationApply/getIdentificationInfoByID', {
					params: {
						identificationID: this.id
					}
				}).then(res => {
					if(res.body.result === 1) {
						let {
							identificationInfo,
							transferFromInfo,
							identificationExInfo,
							examineRemarks
						} = res.body.entity;
						let materiaReslmg = ['licensePicture', 'idcardPicture', 'tradeMarkCertificate', 'authorCertificate'];
						let materiaTit = ['运营执照', '企业负责人身份证照片', '商标证', '盖公章授权书扫描件'];

						//					 	注册
						//												this.registerData[0].context = identificationInfo.identification;
						//												//						this.registerData[1].context = identificationInfo.analyIDcode;
						//												this.registerData[1].context = identificationInfo.regEffectiveTime;
						//												this.registerData[2].context = identificationInfo.createDate;
						//												this.registerData[3].context = identificationInfo.statusRemark;
						//												this.registerData[4].context = identificationInfo.transferDate;
						//												this.registerData[5].context = identificationInfo.transferUnitName;
						//											console.log(identificationInfo.transferUnitName)
						//											     this.registerData[6].context = identificationInfo.identificationTypeRemarks;
						//												this.registerData[7].context = identificationInfo.name;
						this.other = examineRemarks;
						let confirm = ['identification', 'regEffectiveTime', 'createDate', 'statusRemark', 'transferDate', 'transferUnitName', 'identificationTypeRemarks', 'name'];

						confirm.forEach((item, index) => {
							this.registerData[index].context = identificationInfo[item]
						})

			


						this.registeroperation = identificationInfo.operationList;
						this.payment_order = identificationInfo.payment_order

						//						限制词

						if(identificationInfo.identificationType === 3) {
                                 this.materialmg =[]
							this.specialImg = {
								licensePicture: identificationInfo.licensePicture,
								limiterFile: identificationInfo.limiterFile,
								idcardPicture: identificationInfo.idcardPicture
							}

						}else{
						
						this.materialmg = _(materiaReslmg) //不需要显式的使用chain关键字
							.map((v, i) => ({
								tit: materiaTit[i],
								context: identificationInfo[v]
							})).filter(v=>v.context).value();
						}
//console.log(this.materialmg)
						//						续费
						if(identificationExInfo != null) {
							console.log('哈哈')
							this.tableData = identificationExInfo.map((item, index) => {
								//								console.log(item.operationList)
								return {
									date: item.renewEffectiveTime,
									renewaltime: item.createDate,
									state: item.statusRemark,
									types: item.operationList,
									id: item.payment_order
								}

							})
						} else {
							this.tableData = []
						}

						if(transferFromInfo != null) {
							this.makeoverData[0].context = transferFromInfo.organunitName
							this.makeoverData[1].context = transferFromInfo.transferDate
							this.makeover = true;

						} else {
							this.makeover = false;
							//							console.log('哈哈')
						}

					}

				})
			},
			handleDelete({
				index = '',
				row = '',
				type = ''
			} = {}) {

				console.log(index)

				if(type === 1) {
					this.$router.push({
						path: 'perfect',
						//						query: {
						//							indentId: row.payment_order
						//						}
					})
				} else if(type === 2) {
					this.$router.push({
						path: 'indent',
						query: {
							indentId: this.payment_order
						}
					})
				} else if(type === 3) {
					this.$router.push({
						path: 'renew',
						query: {
							name: row.name,
							type: 2,
							id: row.id
						}
					})
				} else if(type === 4) {
					this.$router.push({
						path: 'indent',
						query: {
							indentId: this.payment_order
						}
					})
				} else if(type === 5) {
					this.$router.push({
						path: 'thetransfer',
						query: {
							id: row.id
						}
					})
				}

			}
		},
		watch: {

		}

	}
</script>

<style lang="scss">
	@import "@/assets/css/whole.scss";
	.Madata-box {
		width: 100%;
		border-left: solid #dfdfdf 1px;
		border-right: solid #dfdfdf 1px;
		border-bottom: solid #dfdfdf 1px;
		margin-bottom: 40px;
		.MadataU {
			padding-bottom: 20px;
			.MadataL {
				width: 50%;
				padding: 14px 0;
				/*overflow: hidden;*/
				text-align: left;
				display: inline-block;
				.tit {
					width:180px;
					
					font-size: 15px;
					display: inline-block;
					color: #333;
					vertical-align: top;
				text-align: right;
					
					/*vertical-align:;*/
				}
				/*border: solid red 1px;*/
				.contex {
					/*width: 40px;*/
					font-size: 14px;
					max-width: 300px;
					display: inline-block;
					overflow: hidden;
					vertical-align: bottom;
					/*text-align: center;*/
					margin: 0;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
		}
		.Matit {
			text-align: left;
			background-color: #f9f9f9;
			font-size: 15px;
			color: #333;
			border-top: solid $theme-color 2px;
			font-weight: 500;
			padding: 12px 0 12px 40px;
		}
	}
	
	.Enimg-box {
		width: 80px;
		height: 80px;
		display: inline-block;
		margin-left: 10px;
		/*vertical-align: top;*/
	}
	
	.imgalert {
		img {
			width: 100%;
			max-width: 800px;
		}
	}
</style>